export enum MessageTypes {
    ERROR = 'error',
    INFO = 'info',
    SUCCESS = 'success',
    WARNING = 'warning'
}

export const MessageTypesOrder: Record<MessageTypes, number> = {
    [MessageTypes.ERROR]: 0,
    [MessageTypes.WARNING]: 1,
    [MessageTypes.INFO]: 2,
    [MessageTypes.SUCCESS]: 3
}
